import { ServiceLocator } from 'lbs-pi-handy/src/general-purpose/ServiceLocator';

export function servicesMixin (App) {
  const serviceLocator = new ServiceLocator();

  App.$services = App.prototype.$services =
    App.Vue.$services = App.Vue.prototype.$services = serviceLocator;
}
